import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta() {
	const {
		data: { pageTitle },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{pageTitle}</title>
		</Helmet>
	);
}
